"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _ScrollBar = _interopRequireDefault(require("../ScrollBar"));

var _excluded = ["autoHide", "cellHeight", "children", "height", "lg", "md", "sm", "spacing", "xs"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _core.makeStyles)(function () {
  return {
    root: {
      overflow: "hidden",

      /**
       * The mixture of rem and px set by GridList is
       * causing height issues resulting in overflow.
       * Stick to px for this component to function correctly.
       */
      height: function height(props) {
        return props.height;
      }
    },
    gridList: {
      flexWrap: "nowrap",
      // TODO(nyokabi): Material-ui documentation for Grid list component
      //                promote the list into its own layer on Chrome. This cost
      //                memory but helps keeping high FPS.
      transform: "translateZ(0)",
      height: "100%",
      margin: "0 !important",
      overflow: "initial",
      width: "100%"
    },
    scrollBar: {}
  };
});

function ScrollableGridList(_ref) {
  var autoHide = _ref.autoHide,
      cellHeight = _ref.cellHeight,
      children = _ref.children,
      height = _ref.height,
      lg = _ref.lg,
      md = _ref.md,
      sm = _ref.sm,
      spacing = _ref.spacing,
      xs = _ref.xs,
      props = _objectWithoutProperties(_ref, _excluded);

  var classes = useStyles(_objectSpread(_objectSpread({}, props), {}, {
    height: height || cellHeight
  }));
  var theme = (0, _core.useTheme)();
  var cols = xs || sm || md || lg; // NOTE: Can't use if/else here since useMediaQuery is a hook & all hooks
  //       must be called.

  if ((0, _core.useMediaQuery)(theme.breakpoints.up("sm"))) {
    cols = sm || xs;
  }

  if ((0, _core.useMediaQuery)(theme.breakpoints.up("md"))) {
    cols = md || sm || xs;
  }

  if ((0, _core.useMediaQuery)(theme.breakpoints.up("lg"))) {
    cols = lg || md || sm || xs;
  }

  if (!children) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(_core.Box, {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    className: classes.root
  }, /*#__PURE__*/_react["default"].createElement(_ScrollBar["default"], {
    autoHide: autoHide,
    classes: {
      root: classes.scrollBar
    },
    height: height
  }, /*#__PURE__*/_react["default"].createElement(_core.GridList, {
    cellHeight: cellHeight,
    className: classes.gridList,
    cols: cols,
    spacing: spacing
  }, children)));
}

ScrollableGridList.propTypes = {
  autoHide: _propTypes["default"].bool,
  cellHeight: _propTypes["default"].number,
  children: _propTypes["default"].node,
  height: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]).isRequired,
  // in px
  lg: _propTypes["default"].number,
  md: _propTypes["default"].number,
  sm: _propTypes["default"].number,
  spacing: _propTypes["default"].number,
  xs: _propTypes["default"].number.isRequired
};
ScrollableGridList.defaultProps = {
  autoHide: false,
  cellHeight: undefined,
  children: undefined,
  lg: undefined,
  md: undefined,
  sm: undefined,
  spacing: 16
};
var _default = ScrollableGridList;
exports["default"] = _default;